import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="container-fluid p-0">
      <header className="bg-light shadow-sm">
        <div className="container py-3">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="fw-bold mb-0">Emit</h1>
              <small className="fw-bold" style={{fontStyle: 'italic'}}>
                Powered by <span style={{color: '#0d6efd'}}>F</span><span style={{color: '#dc3545'}}>h</span><span style={{color: '#28a745'}}>o</span>ism
              </small>
            </div>
            <div>
              <Link to="/login" className="btn btn-outline-primary me-2">Login</Link>
              <Link to="/register" className="btn btn-primary">Get Started</Link>
            </div>
          </div>
        </div>
      </header>
      
      <main>
        <div className="container py-5">
          <div className="text-center mb-5">
            <h2 className="display-4 fw-bold">Transform Your Consciousness</h2>
            <p className="lead text-muted">Mindfulness, self-development, and spirituality platform</p>
            <div className="mt-4">
              <Link to="/register" className="btn btn-primary btn-lg">Begin Your Journey</Link>
            </div>
          </div>
          
          <div className="row row-cols-1 row-cols-md-3 g-4 mt-5">
            <div className="col">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h3 className="card-title">🧭 Exploration Tier</h3>
                  <p className="card-text display-6">$45/month</p>
                  <p className="card-text text-muted">Begin your spiritual growth journey and explore the foundations of personal development</p>
                  <ul className="list-group list-group-flush mt-3">
                    <li className="list-group-item">200,000 tokens per month</li>
                    <li className="list-group-item">Standard transformation depth</li>
                    <li className="list-group-item">Email support</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="col">
              <div className="card h-100 shadow border-primary">
                <div className="card-body">
                  <h3 className="card-title">💫 Transformation Tier</h3>
                  <p className="card-text display-6">$85/month</p>
                  <p className="card-text text-muted">For those committed to the "Transformation of Self" (TOS) journey</p>
                  <ul className="list-group list-group-flush mt-3">
                    <li className="list-group-item">500,000 tokens per month</li>
                    <li className="list-group-item">Advanced transformation depth</li>
                    <li className="list-group-item">Priority email support</li>
                    <li className="list-group-item">Additional tools and templates</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="col">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <h3 className="card-title">🚀 Creation Tier</h3>
                  <p className="card-text display-6">$125/month</p>
                  <p className="card-text text-muted">For professionals and committed practitioners seeking the deepest transformation</p>
                  <ul className="list-group list-group-flush mt-3">
                    <li className="list-group-item">1,500,000 tokens per month</li>
                    <li className="list-group-item">Maximum transformation depth</li>
                    <li className="list-group-item">Premium support</li>
                    <li className="list-group-item">Complete toolkit and multi-platform</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <footer className="bg-light py-4 mt-5">
        <div className="container text-center">
          <p className="text-muted">© 2026 Emit - Consciousness Transformation Platform</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
